import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import BaseItem from "../BaseItem";
import Column from "../Column";
import NavList from "../NavList";
import NavItem from "../NavItem";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { AuthState, getRehydratableName, getClassNameFactory } from "../../../../utilities";

var Login = /*#__PURE__*/function (_Component) {
  _inherits(Login, _Component);

  var _super = _createSuper(Login);

  function Login(props) {
    var _this;

    _classCallCheck(this, Login);

    _this = _super.call(this, props);
    _this.handleLogin = _this.handleLogin.bind(_assertThisInitialized(_this));
    _this.handleLogout = _this.handleLogout.bind(_assertThisInitialized(_this));
    _this.loginManagerChange = _this.loginManagerChange.bind(_assertThisInitialized(_this));

    if (_this.props.loginManager) {
      _this.props.loginManager.onChange(_this.loginManagerChange);
    }

    return _this;
  }

  _createClass(Login, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.loginManager) {
        this.props.loginManager.offChange(this.loginManagerChange);
      }
    }
  }, {
    key: "handleLogin",
    value: function handleLogin() {
      if (this.props.loginManager) {
        this.props.loginManager.login();
      }
    }
  }, {
    key: "handleLogout",
    value: function handleLogout() {
      if (this.props.loginManager) {
        this.props.loginManager.logout();
      }
    }
  }, {
    key: "loginManagerChange",
    value: function loginManagerChange() {
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var getClassName = getClassNameFactory("GlobalHeaderLogin");

      var Wrapper = function Wrapper(_ref) {
        var children = _ref.children;
        return /*#__PURE__*/React.createElement("li", {
          className: getClassName(),
          "data-account-label": _this2.props.accountLabel,
          "data-account-overview-label": _this2.props.accountOverviewLabel,
          "data-hello-label": _this2.props.helloLabel,
          "data-login-label": _this2.props.loginLabel,
          "data-logout-label": _this2.props.logoutLabel,
          "data-rehydratable": getRehydratableName(Login.displayName)
        }, children);
      };

      if (!this.props.loginManager) {
        return /*#__PURE__*/React.createElement(Wrapper, null);
      }

      var loginUserDisplayName = this.props.loginManager.userFirstName || this.props.loginManager.userName;
      return /*#__PURE__*/React.createElement(Wrapper, null, this.props.loginManager.authState === AuthState.LOGGED_IN ? /*#__PURE__*/React.createElement(BaseItem, _extends({}, this.props, {
        label: this.props.accountLabel,
        longLabel: "".concat(this.props.helloLabel, ", ").concat(loginUserDisplayName)
      }), /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(NavList, null, this.props.accountOverviewLabel && /*#__PURE__*/React.createElement(NavItem, {
        title: this.props.accountOverviewLabel,
        href: this.props.loginManager.accountOverviewUrl
      }), this.props.logoutLabel && /*#__PURE__*/React.createElement(NavItem, {
        title: this.props.logoutLabel,
        onClick: this.handleLogout,
        href: this.props.loginManager.logoutUrl
      })))) : /*#__PURE__*/React.createElement(BaseItem, _extends({}, this.props, {
        label: this.props.loginLabel,
        onClick: this.handleLogin,
        href: this.props.loginManager.loginUrl
      })));
    }
  }]);

  return Login;
}(Component);

_defineProperty(Login, "displayName", "GlobalHeader.Login");

_defineProperty(Login, "propTypes", {
  /**
   * The account label to show on this Login.
   */
  accountLabel: PropTypes.string.isRequired,

  /**
   * The account overview label to show on this Login.
   */
  accountOverviewLabel: PropTypes.string.isRequired,

  /**
   * The hello label to show on this Login.
   */
  helloLabel: PropTypes.string.isRequired,

  /**
   * The login label to show on this Login.
   */
  loginLabel: PropTypes.string.isRequired,

  /**
   * The logout label to show on this Login.
   */
  logoutLabel: PropTypes.string.isRequired,

  /**
   * LoginManager instance, required at rehydration.
   */
  loginManager: PropTypes.object
});

export default Login;